export default {
  type: "object",
  category: "camera",
  target: { type: "camera", key: "camera" },
  groups: [],
  "feature-flags": ["APP_BLOCK_CAMERA"],
};
